import vmodal from "@/packages/vmodal";
import VueMask from "v-mask";
import Vue from "vue";
import router from "./apps/clientPortal/router";
import store from "./apps/clientPortal/store";
import global from "./apps/movingBuddies/mixins/global";
import Http from "./classes/Http";
import authed from "./mixins/authed";
import checkRoute from "./mixins/checkRoute";
import detect from "./mixins/detect";
import enums from "./mixins/enums";
import form from "./mixins/form";
import permissions from "./mixins/permissions";
import present from "./mixins/present";
import refs from "./mixins/refs";
import route from "./mixins/route";
import scrollTo from "./mixins/scrollTo";
import setScrollSize from "./mixins/setScrollSize";

window.http = new Http("httpClient");
window.externalHttp = new Http("externalHttpClient");
window._ = require("lodash");
window.Qs = require("qs");
window.tween = require("@tweenjs/tween.js");

Vue.component("loading-layout", require("./apps/movingBuddies/layouts/Loading").default);
Vue.component("auth-layout", require("./apps/movingBuddies/layouts/Auth").default);
Vue.component("default-layout", require("./apps/movingBuddies/layouts/Portal").default);
Vue.component("error-layout", require("./layouts/Error").default);
Vue.component("app", require("./apps/movingBuddies/App").default);
Vue.component("info-button", require("./apps/movingBuddies/components/InfoButton").default);
Vue.component("alert", require("./components/Alert").default);
Vue.component("alert-container", require("./components/AlertContainer").default);
Vue.component("loader", require("./components/GenericLoader").default);
// Vue.component("v-datepicker", require("./common/components/v-datepicker/v-datepicker").default);
// Vue.component("v-datepicker-calendar", require("./common/components/v-datepicker/v-datepicker-calendar").default);
Vue.component("v-dobpicker", require("./common/components/v-dobpicker/v-dobpicker").default);
Vue.component("v-modal", require("./components/v-modal").default);
Vue.component("v-table", require("./common/components/v-table/v-table").default);
Vue.component("v-tabs", require("./common/components/v-tabs/v-tabs").default);
Vue.component("v-tab", require("./common/components/v-tabs/v-tab").default);
Vue.component("v-upload", require("./common/components/v-upload/v-upload").default);
Vue.component("v-filemanager", require("./common/components/v-filemanager/v-filemanager").default);
Vue.component("v-signature", require("./common/components/v-signature/v-signature").default);
Vue.component("process-button", require("./components/ProcessButton").default);
Vue.component("progress-indicator", require("./components/ProgressIndicator").default);
Vue.component("status-badge", require("./components/StatusBadge").default);
Vue.component("bool-icon", require("./components/BoolIcon").default);
Vue.component("money", require("./components/Money").default);

Vue.mixin(authed);
Vue.mixin(checkRoute);
Vue.mixin(detect);
Vue.mixin(form(http(), store));
Vue.mixin(enums);
Vue.mixin(permissions);
Vue.mixin(present);
Vue.mixin(refs);
Vue.mixin(route);
Vue.mixin(global);
Vue.mixin(scrollTo);
Vue.mixin(setScrollSize);

// Vue.use(VCalendar, {});
Vue.use(vmodal);
Vue.use(VueMask);

window.app = new Vue({
	el: "#app",
	router,
	store,
	created() {
		store.dispatch("authStore/authed");
	},
});



